// @flow
import React from "react";
import moment from "moment";
import "moment/locale/tr";
import * as Sentry from "@sentry/react";
import {StoreProvider} from "./store/appContext";
import Routes from "./routes/index";
import stores from "./store/stores";
import CacheBuster from "./CacheBuster";
import FallbackComponent from "./components/_defaultComponents/FilterComponents/FallbackComponent";
moment.locale("tr");

function App() {
    const AppContent = (
        <StoreProvider value={stores}>
            <React.Suspense fallback={<FallbackComponent />}>{<Routes />}</React.Suspense>
        </StoreProvider>
    );

    const content = (
        <CacheBuster>
            {({loading, isLatestVersion, refreshCacheAndReload}) => {
                if (loading) return null;
                if (!loading && !isLatestVersion) {
                    refreshCacheAndReload();
                }

                return AppContent;
            }}
        </CacheBuster>
    );

    if (process.env.NODE_ENV !== "development") {
        return (
            <Sentry.ErrorBoundary fallback={<FallbackComponent />}>{content}</Sentry.ErrorBoundary>
        );
    }
    return content;
}

export default App;
